import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { AdminAuthProvider, useAdminAuth } from './AdminAuth';
import { AdminShell } from './AdminShell';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import ResourceListPage from './ResourceListPage';
import ResourceEditPage from './ResourceEditPage';
import AvailabilityPage from './AvailabilityPage';
import BookingsPage from './BookingsPage';
import EnquiriesPage from './EnquiriesPage';
import MediaPage from './MediaPage';
import SettingsPage from './SettingsPage';
import NavigationPage from './NavigationPage';
import UsersPage from './UsersPage';
import AuditPage from './AuditPage';
import AnalyticsPage from './AnalyticsPage';

function RequireAuth({ children, roles }) {
  const { user } = useAdminAuth();
  const location = useLocation();
  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-100" role="status">
        <Loader2 className="h-6 w-6 animate-spin text-navy-900" />
        <span className="sr-only">Checking your session</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/admin" replace />;
  return children;
}

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="/login" element={<AdminLogin />} />
        <Route element={<RequireAuth><AdminShell /></RequireAuth>}>
          <Route index element={<AdminDashboard />} />
          <Route path="content/:resource" element={<ResourceListPage />} />
          <Route path="content/:resource/new" element={<ResourceEditPage />} />
          <Route path="content/:resource/:id/edit" element={<ResourceEditPage />} />
          <Route path="availability" element={<RequireAuth roles={['owner', 'administrator']}><AvailabilityPage /></RequireAuth>} />
          <Route path="bookings" element={<RequireAuth roles={['owner', 'administrator']}><BookingsPage /></RequireAuth>} />
          <Route path="enquiries" element={<RequireAuth roles={['owner', 'administrator']}><EnquiriesPage /></RequireAuth>} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="media" element={<MediaPage />} />
          <Route path="settings" element={<RequireAuth roles={['owner', 'administrator']}><SettingsPage /></RequireAuth>} />
          <Route path="navigation" element={<RequireAuth roles={['owner', 'administrator']}><NavigationPage /></RequireAuth>} />
          <Route path="users" element={<RequireAuth roles={['owner']}><UsersPage /></RequireAuth>} />
          <Route path="audit" element={<RequireAuth roles={['owner', 'administrator']}><AuditPage /></RequireAuth>} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Route>
      </Routes>
    </AdminAuthProvider>
  );
}
